import React from 'react';
import PropTypes from 'prop-types';

const RoomsListCS = ({ id }) => {
	return (
		<div className="grk-card -sizeSectPrfl" id={id}>
			<div className="prfl-empty-img">
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
			</div>
			<div className="prfl-empty-desc">
				<div className="prfl-empty-line" />
				<div className="prfl-empty-line" />
				<div className="prfl-empty-line" />
			</div>
		</div>
	);
};

RoomsListCS.propTypes = {
	id: PropTypes.string,
};

RoomsListCS.defaultProps = {
	id: undefined,
};

export default RoomsListCS;
